import React from "react";
import Navbar from "../components/NavBar";
import "../styles/AboutUs.css";

import { FaTruckMoving, FaUsers, FaShieldAlt } from "react-icons/fa";

function About() {
  return (
    <>
      <Navbar />

      {/* HERO */}
      <section className="about-hero">
        <div className="about-hero-image">
          <img src={require('../assets/Hero-Images/About-Hero-Image.jpeg')} alt="Moving Services" />
        </div>
        <div className="about-content">
          <h2>Who We Are</h2>

          <p>
            AMF Movers LTD is a professional moving and relocation company
            committed to delivering safe, reliable, and efficient services.
            We specialize in residential and commercial moving, ensuring every
            item is handled with care and professionalism.
          </p>

          <p>
            With a dedicated team and a customer-first approach, we provide
            complete moving solutions — from packing and transportation to
            installation and setup. Our goal is simple: to make every move
            smooth, secure, and stress-free.
          </p>

          <p>
            At AMF Movers LTD, we believe in integrity, punctuality, and
            excellence. We treat every client’s property as if it were our own,
            offering dependable service you can trust.
          </p>
        </div>
      </section>

      {/* MISSION && VISION */}

      <section className="mission-section">

        <div className="mission-grid">

          <div className="mission-card">
            <FaTruckMoving className="mission-icon" />
            <h3>Our Mission</h3>
            <p>
              To provide reliable, safe, and professional moving services
              that make relocation easy and stress-free for every client.
            </p>
          </div>

          <div className="mission-card">
            <FaUsers className="mission-icon" />
            <h3>Customer Commitment</h3>
            <p>
              We prioritize our clients by offering dependable service,
              clear communication, and solutions tailored to their needs.
            </p>
          </div>

          <div className="mission-card">
            <FaShieldAlt className="mission-icon" />
            <h3>Our Promise</h3>
            <p>
              We handle every item with care and ensure your belongings
              arrive safely and on time.
            </p>
          </div>

        </div>

      </section>

      {/* CTA */}

      <section className="about-cta">
        <h2>Planning a Move?</h2>
        <p>Let AMF Movers make your relocation smooth and stress-free.</p>

        <a href="/#quote">
          <button className="cta-btn">Get a Quote</button>
        </a>
      </section>

    </>
  );
}

export default About;